import { getStorageItem } from 'utils/helpers';

export const storageKeys = {
  MANUFACTURER_ID: 'manufacturerId',
} as const;

export const defaultValues = {
  MANUFACTURER_ID: getStorageItem(storageKeys.MANUFACTURER_ID, ''),
};
